module.exports = __webpack_public_path__ + "img/chenxiaohua.6e37ffa9.png";